// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1OeYN","savePackageButton":"ClientWallet_savePackageButton__DfrqS"};